import insertIcon from './insertIcon'
import arrowRight from './icons/icon_arrow_right.svg'
import arrowLeft from './icons/icon_arrow_left.svg'
import arrowDescription from './icons/icon_arrow_desc.svg'
import tgIcon from './icons/icon_share_telegram.svg'
import vkIcon from './icons/icon_share_vk.svg'
import okIcon from './icons/icon_share_ok.svg'
import instIcon from './icons/icon_share_instagram.svg'
import crtLogo from './icons/icon-logo-ct.svg'

export default () => {
  insertIcon('#footerDtr', crtLogo)
  const descriptionArrows = document.querySelectorAll('.promo-unit-content__desc-icon')
  const sectionLinkArrow = document.querySelectorAll('.action .action__icon')


  if (descriptionArrows.length > 0) {
    descriptionArrows.forEach(arrow => arrow.innerHTML  = arrowDescription)
  }

  if (sectionLinkArrow.length > 0) {
    sectionLinkArrow.forEach(link => link.innerHTML = arrowRight)
  }

  const next = document.querySelector('.carousel-button__icon--next')
  const prev = document.querySelector('.carousel-button__icon--prev')

  if (next && prev) {
    next.innerHTML = arrowRight
    prev.innerHTML = arrowLeft
  }

  document.querySelectorAll('.carousel__button--prev .carousel__icon').forEach(icon => icon.innerHTML = arrowLeft)
  document.querySelectorAll('.carousel__button--next .carousel__icon').forEach(icon => icon.innerHTML = arrowRight)

  if (document.querySelectorAll('.social-share__link').length > 0) {
    document.querySelectorAll('.social-share__link').forEach(link => {
      const linkTitle = link.getAttribute('title')

      switch (linkTitle) {
        case 'vk':
          link.innerHTML = vkIcon
          break
        
        case 'ok':  
          link.innerHTML = okIcon
          break

        case 'instagram':
          link.innerHTML = instIcon  

        case 'telegram':
          link.innerHTML = tgIcon

        default:
          link.innerHTML = instIcon
          break
      }
    })
  }
}